import colors from "./colors"
import shadows from "./shadows"
import typography from "./typography"

export default {
  colors,
  shadows,
  ...typography,
}
